(() => {
  const stateKey = '__bwNavigationState';
  const railSelector = 'slider-component .slider, [data-bw-history-scroll]';
  const restoreDelays = [0, 80, 200, 450, 800, 1300, 2200, 4000];
  let restoreTimers = [];
  let userInteracted = false;
  let navigationSnapshotSaved = false;

  const pageKey = () => `${window.location.pathname}${window.location.search}${window.location.hash}`;

  const getRails = () => Array.from(document.querySelectorAll(railSelector));

  const railPosition = rail => {
    const section = rail.closest('[id^="shopify-section-"]');
    const sectionRails = section ? Array.from(section.querySelectorAll(railSelector)) : [];
    return {
      id: rail.id || '',
      sectionId: section ? section.id : '',
      sectionIndex: section ? sectionRails.indexOf(rail) : -1,
      left: rail.scrollLeft,
      top: rail.scrollTop,
    };
  };

  const snapshot = () => ({
    page: pageKey(),
    x: window.scrollX,
    y: window.scrollY,
    rails: getRails().map(railPosition),
  });

  const save = () => {
    try {
      const currentState = history.state && typeof history.state === 'object' ? history.state : {};
      history.replaceState({ ...currentState, [stateKey]: snapshot() }, '', window.location.href);
      return true;
    } catch (error) {
      // Navigation must never be blocked if a browser refuses a history-state write.
      return false;
    }
  };

  const savedState = () => {
    const state = history.state && history.state[stateKey];
    return state && state.page === pageKey() ? state : null;
  };

  const restore = state => {
    if (!state || userInteracted) return;

    const root = document.documentElement;
    const previousBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = 'auto';
    window.scrollTo(Number(state.x) || 0, Number(state.y) || 0);
    root.style.scrollBehavior = previousBehavior;

    (state.rails || []).forEach(position => {
      const section = position.sectionId ? document.getElementById(position.sectionId) : null;
      const sectionRails = section ? Array.from(section.querySelectorAll(railSelector)) : [];
      const rail = position.id
        ? document.getElementById(position.id)
        : sectionRails[position.sectionIndex];
      if (!rail) return;
      const previousBehavior = rail.style.scrollBehavior;
      rail.style.scrollBehavior = 'auto';
      rail.scrollLeft = Number(position.left) || 0;
      rail.scrollTop = Number(position.top) || 0;
      const slider = rail.closest('slider-component');
      if (slider && typeof slider.resetPages === 'function') slider.resetPages();
      rail.style.scrollBehavior = previousBehavior;
    });
  };

  const cancelRestore = event => {
    const historyShortcut = event.type === 'keydown'
      && (event.altKey || event.metaKey)
      && (event.key === 'ArrowLeft' || event.key === 'ArrowRight');
    if (historyShortcut) return;
    navigationSnapshotSaved = false;
    userInteracted = true;
    restoreTimers.forEach(timer => window.clearTimeout(timer));
    restoreTimers = [];
  };

  const scheduleRestore = state => {
    if (!state) return;
    userInteracted = false;
    restoreTimers.forEach(timer => window.clearTimeout(timer));
    restoreTimers = restoreDelays.map(delay => window.setTimeout(() => {
      window.requestAnimationFrame(() => restore(state));
    }, delay));
  };

  ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(eventName => {
    window.addEventListener(eventName, cancelRestore, { capture: true, passive: true });
  });

  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target && typeof event.target.closest === 'function'
      ? event.target.closest('a[href]')
      : null;
    if (!link || (link.target && link.target !== '_self') || link.hasAttribute('download')) return;

    try {
      const destination = new URL(link.href, window.location.href);
      const sameDocument = destination.pathname === window.location.pathname
        && destination.search === window.location.search;
      if (destination.origin === window.location.origin && !sameDocument) {
        navigationSnapshotSaved = save();
      }
    } catch (error) {
      // Ignore malformed or non-standard link targets.
    }
  });

  window.addEventListener('pagehide', () => {
    if (!navigationSnapshotSaved) save();
  });
  window.addEventListener('pageshow', event => {
    navigationSnapshotSaved = false;
    const navigation = window.performance && window.performance.getEntriesByType
      ? window.performance.getEntriesByType('navigation')[0]
      : null;
    const legacyHistoryReturn = window.performance
      && window.performance.navigation
      && window.performance.navigation.type === 2;
    const historyReturn = event.persisted || legacyHistoryReturn || (navigation && navigation.type === 'back_forward');
    if (historyReturn) scheduleRestore(savedState());
  });
})();
